module.exports = __webpack_public_path__ + "static/media/mz.d1a7954d.svg";